import { render, staticRenderFns } from "./IncomingMessageWidget.vue?vue&type=template&id=1739c2ec&scoped=true&"
import script from "./IncomingMessageWidget.vue?vue&type=script&lang=js&"
export * from "./IncomingMessageWidget.vue?vue&type=script&lang=js&"
import style0 from "./IncomingMessageWidget.vue?vue&type=style&index=0&id=1739c2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1739c2ec",
  null
  
)

export default component.exports